<template>
  <div>
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>

    <div class="gameplay_game_box">
      <img :src="gameInfo.img" @load="loadImage" class="">
      <div class="gameplay_divider"></div>

      <div v-for="row in (gameInfo.questions.length / 2)" :key="row" class="gameplay_btns_row">
        <button :disabled="buttonPushed" v-for="(answer, index) in getPartOfAnswers(row)" :key="index"
                @click="sendAnswer(row, (index + 1))"
                class="gameplay_btn attention select_answer" :ref="index + 1" style="cursor: pointer">
          {{ answer }}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
  /* eslint no-console: "off" */

import { mapGetters, mapState } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { GameMixin2, ParseResponseMixin } from '@/common/mixins/game';
import { equalHeightAndWidth, gameplayFooter } from '@/common/jQuery';

export default {
  name: 'LogicSlices',
  mixins: [ParseResponseMixin, NewGameMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      buttonPushed: false,
    };
  },
  created() {
    this.initGameData();
  },
  mounted() {
    equalHeightAndWidth();
  },
  methods: {
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.gameInfo.questions.slice(0, this.gameInfo.questions.length / 2);
      }
      return this.gameInfo.questions.slice(this.gameInfo.questions.length / 2);
    },
    calculateRefIndex(indexToBack) {
      // eslint-disable-next-line no-nested-ternary
      return (indexToBack === 0) ? this.$refs[1][0] : (indexToBack === 1) ? this.$refs[2][0] : (indexToBack === 2) ? this.$refs[1][1] : this.$refs[2][1];
    },
    sendAnswer(row, index) {
      // eslint-disable-next-line no-nested-ternary
      const indexToBack = (row === 1) ? ((row * index) - 1) : (index === 1) ? 2 : 3;
      let isCorrectAnswer = false;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${indexToBack}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.calculateRefIndex(indexToBack).classList.add('gameplay_btn_false');
              this.calculateRefIndex(responseData.correctIndex).classList.add('gameplay_btn_correct');
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.calculateRefIndex(indexToBack).classList.add('gameplay_btn_correct');
            }
          }
          console.log('wait 1,5 secs for response and go to next game');
          setTimeout(() => {
            console.log('Go to next game');
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/logic/LogicSlices.vue